import { fetchFromAPI } from '../services/common';
import { listEnabledPractices } from '../services/paymentsService';

const ENABLED_PRACTICES_KEY = 'paymentsEnabledPractices';

export function isSentinelPracticeId(id) {
  const s = String(id || '').toLowerCase();
  return s.endsWith('admin') || s.endsWith('callcenter');
}

export function normalizeAllowedPractices(raw) {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((p) => (typeof p === 'string' ? { practiceId: p, name: '' } : p))
    .filter((p) => p?.practiceId && !isSentinelPracticeId(p.practiceId));
}

export function practiceDisplayName(practice) {
  if (!practice) return '';
  const name = String(practice.name || '').trim();
  return name || practice.practiceId;
}

export function sortPracticesByName(practices) {
  return [...practices].sort((a, b) =>
    practiceDisplayName(a).localeCompare(practiceDisplayName(b), undefined, {
      sensitivity: 'base',
    })
  );
}

export function readSelectablePractices() {
  try {
    const enabled = JSON.parse(localStorage.getItem(ENABLED_PRACTICES_KEY) || 'null');
    if (Array.isArray(enabled)) {
      return sortPracticesByName(normalizeAllowedPractices(enabled));
    }
  } catch {
    // no cached enabled list yet
  }
  return [];
}

export function cacheEnabledPractices(practices) {
  localStorage.setItem(ENABLED_PRACTICES_KEY, JSON.stringify(practices || []));
  return sortPracticesByName(normalizeAllowedPractices(practices || []));
}

export async function loadEnabledPractices() {
  const practices = await listEnabledPractices();
  return cacheEnabledPractices(practices);
}

export function pickLoginPracticeId(selectable, details) {
  const saved = details?.lastSelectedPracticeId;
  if (saved && selectable.some((p) => p.practiceId === saved)) return saved;
  if (details?.practiceId && selectable.some((p) => p.practiceId === details.practiceId)) {
    return details.practiceId;
  }
  return selectable[0]?.practiceId || '';
}

export async function persistPracticeSelection(practiceId, userIdOverride) {
  const userId =
    userIdOverride ||
    localStorage.getItem('useremail') ||
    localStorage.getItem('email');
  if (!userId || !practiceId) return;
  try {
    await fetchFromAPI(`/api/users/${encodeURIComponent(userId)}/practice-selection`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ practiceId }),
    });
  } catch (err) {
    console.warn('Failed to persist practice selection:', err);
  }
}
